import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import firebaseConfig from "../../../../firebase/firebaseConfig"

Vue.use(VueGoogleMaps, {
  load: {
    key: firebaseConfig.apiKey,
    libraries: 'places',
    region: 'JP',
    language: 'ja'
  }
})